// このファイルはService Workerの登録と管理を行います

// 本番環境かどうかを確認
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

type Config = {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
};

// Service Workerの登録
export function register(config?: Config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL || '', window.location.href);
    
    // PUBLIC_URLが別オリジンの場合はService Workerを登録しない
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // ローカルホストの場合はService Workerが存在するか確認
        checkValidServiceWorker(swUrl, config);

        // ローカルホストの場合は追加のログを表示
        navigator.serviceWorker.ready.then(() => {
          console.log(
            'このアプリケーションはService Workerによってキャッシュされています。'
          );
        });
      } else {
        // ローカルホスト以外の場合はService Workerを登録
        registerValidSW(swUrl, config);
      }
    });
  }
}

// Service Workerの登録処理
function registerValidSW(swUrl: string, config?: Config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // 新しいコンテンツが利用可能
              console.log('新しいコンテンツが利用可能です。更新してください。');

              // コールバックの実行
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // 初回のService Worker登録
              console.log('コンテンツがオフライン用にキャッシュされました。');

              // コールバックの実行
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Service Workerの登録中にエラーが発生しました:', error);
    });
}

// Service Workerの有効性確認
function checkValidServiceWorker(swUrl: string, config?: Config) {
  // Service Workerが存在するか確認
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      // 404またはContent-Typeが正しくない場合
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // Service Workerが見つからない場合はページをリロード
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service Workerが見つかった場合は登録
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('インターネット接続がありません。オフラインモードで実行中です。');
    });
}

// Service Workerの登録解除
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
